/**
 * Tracks matrix-js-sdk crypto bootstrap completion (initRustCrypto + startClient + initKeySharing).
 * The UI must not send encrypted messages until this resolves.
 */
let cryptoInitPromise = null;
let cryptoReady = false;
export const setCryptoInitPromise = (promise) => {
    cryptoReady = false;
    cryptoInitPromise = promise
        .then((result) => {
        cryptoReady = result;
        return result;
    })
        .catch((error) => {
        cryptoReady = false;
        throw error;
    });
};
export const waitForCryptoReady = async () => {
    if (cryptoReady)
        return true;
    if (!cryptoInitPromise)
        return false;
    try {
        return await cryptoInitPromise;
    }
    catch {
        return false;
    }
};
export const isCryptoReady = () => cryptoReady;
export const resetCryptoReady = () => {
    cryptoReady = false;
    cryptoInitPromise = null;
};
